export enum CarePartnersDataIndex {
  'full_name' = 'full_name',
  'email' = 'email',
  'phone_number' = 'phone_number',
  'status' = 'status',
  'cms_navigators.full_name' = 'cms_navigators.full_name',
  'content_language' = 'content_language',
}
